import React from 'react';
import { serializeJsonForScript } from '../lib/publicPage';

interface HeadJsonLdProps {
  id: string;
  data: unknown;
}

const HeadJsonLd: React.FC<HeadJsonLdProps> = ({ id, data }) => {
  const content = serializeJsonForScript(data);

  React.useEffect(() => {
    const existing = document.getElementById(id) as HTMLScriptElement | null;
    const script = existing || document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.textContent = content;
    if (!existing) document.head.appendChild(script);
    return () => {
      if (document.getElementById(id) === script) script.remove();
    };
  }, [id, content]);

  if (typeof window !== 'undefined') return null;
  return <script id={id} type="application/ld+json" dangerouslySetInnerHTML={{ __html: content }} />;
};

export default HeadJsonLd;
